export function groupLabelsByCategory(labels = []) {
	let groupedLabels = {};

	labels.forEach((label) => {
		if (!groupedLabels[label.categoryGroup]) {
			groupedLabels[label.categoryGroup] = [];
		}

		groupedLabels[label.categoryGroup].push({
			...label,
			id:label.labelId,
		});
	});

	return groupedLabels;
}

export const CATEGORY_GROUP_ORDER = {
	Advertiser: 0,
	Vertical: 1,
	"General Content": 2,
	Design: 3,
};

export function getCategoryGroupOrder(group){
	if(/^Vertical:/i.test(group)){
		// Anything starting with "Vertical:" is given the same sorting tier
		return CATEGORY_GROUP_ORDER.Vertical;
	}
	return CATEGORY_GROUP_ORDER[group];
}

export function sortCategoryGroups(groupA, groupB){
	const max = Object.keys(CATEGORY_GROUP_ORDER).length;
	const groupAOrder = getCategoryGroupOrder(groupA) ?? max;
	const groupBOrder = getCategoryGroupOrder(groupB) ?? max;

	if(groupAOrder === groupBOrder){
		return groupA.localeCompare(groupB);
	}

	return groupAOrder - groupBOrder;
}

export function sortCategoryGroupsWithMap(map = item => item){
	return (groupA, groupB) => sortCategoryGroups(map(groupA), map(groupB));
}
